import { AnimatedOutlet } from "@/components/shared/animated-outlet";

/**
 * 콘텐츠 영역의 레이아웃
 * 최대 너비 제한과 중앙 정렬을 적용함
 */
export function ContentLayout() {
  return (
    <div className="flex flex-col min-h-screen items-center">
      <main className="flex-1 size-full w-full bg-background">
        <AnimatedOutlet />
      </main>
    </div>
  );
}
